import { type FormatDateOptions } from 'react-intl';

const getDefaultFormatDateOptions = (): FormatDateOptions => ({
	year: 'numeric',
	month: 'short',
	day: '2-digit',
	hour: '2-digit',
	minute: '2-digit',
});

export function formatSuggestedDateTime(
	value: unknown,
	formatDate: (
		value: string | number | Date | undefined,
		opts?: FormatDateOptions | undefined,
	) => string,
): string | undefined {
	if (!value) {
		return undefined;
	}

	const defaultFormatDateOptions = getDefaultFormatDateOptions();

	if (typeof value === 'string') {
		const trimmedValue = value.trim();
		if (trimmedValue.length === 0) {
			return undefined;
		}

		if (
			/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(trimmedValue)
		) {
			const isoDate = new Date(trimmedValue);
			if (!Number.isNaN(isoDate.getTime())) {
				return formatDate(isoDate, defaultFormatDateOptions);
			}
			return trimmedValue;
		}

		return trimmedValue;
	}

	if (typeof value === 'number') {
		const date = new Date(value);
		if (!Number.isNaN(date.getTime())) {
			return formatDate(date, defaultFormatDateOptions);
		}
	}

	return String(value);
}
